import { useDispatch, useSelector } from "react-redux";
import AcquisitionCodeMaintenance from "./AcquisitionCodeMaintenance"
import { useCallback, useEffect, useRef, useState } from "react";
import { getAcquisitionCodeMaintenanceExcelData, getAcquisitionCodeMaintenanceGridData, getUpdatedByAcquisitionList, saveDiscountFlag, setAcquisitionCodeMaintenanceExcelData, setDiscountFlag } from "Store/Report/AcquisitionCodeMaintenance/AcquisitionCodeMaintenanceAction";
import { SwitchToggle } from "client/CommonComponents";
import moment from "moment";
import { CustomDateFilterComponent, CustomDropdownFilterComponent } from "../BulkOrder/Home/HomeHelper";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";
import { COLUMN_FILTERS } from "client/utils/constants/homeGridConstants";
import GridDataFiltersAction from "Store/Component/GridDataFilters/GridDataFiltersAction"
import userProfileSelectors from '../../../../redux/UserProfile/selectors';
import { base64ToArrayBuffer, saveByteArray } from "utils";
import { useNavigate } from "react-router-dom";
import {operations} from 'redux/Navigation';
import permissions, { isAuthorized } from "client/utils/Permissions";

const AcquisitionCodeMaintenanceContainer = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [gridData, setGridData] = useState([])
    const [paginationData, setPaginationData] = useState<any>({})
    const [pagesCount, setPagesCount] = useState<number>(0)
    const [serverTotal, setServerTotal] = useState(0)
    const [sortData, setSortData] = useState<any>('')
    const [searchValue, setSearchValue] = useState('')
    const selectUpdatedBy = useRef('');
    const selectDiscountFlag = useRef('');
    const updatedDate = useRef<any>(null);
    const updatedByDropdownList: any = useRef(null);
    const [descriptionFilter, setDescriptionFilter] = useState<any>('')
    const [codeFilter, setCodeFilter] = useState<any>('')
    const discountFlagDropdownList = [{ label: 'True', value: 'Yes', text: 'Yes' }, { label: 'False', value: 'No', test: 'No' }]
    const navDispatch = operations.dispatchNav(dispatch);
    const dispatchHeaderNav = operations.dispatchHeaderNav(dispatch)
    const [showGrid, setShowGrid] = useState<any>(false);

    const {
        acquisitionCodeMaintenanceGridData,
        acquisitionCodeMaintenanceExcelData,
        isDiscountFlag,
        updatedByList,
        acquisitionCodeMaintenanceGridFilters,
        userDetails
    }: any = useSelector(
        (state: any) => ({
            acquisitionCodeMaintenanceGridData: state.AcquisitionCodeMaintenanceReducer.acquisitionCodeMaintenanceGridData,
            acquisitionCodeMaintenanceExcelData: state.AcquisitionCodeMaintenanceReducer.acquisitionCodeMaintenanceExcelData,
            updatedByList: state.AcquisitionCodeMaintenanceReducer.updatedByDropdownList,
            isDiscountFlag: state.AcquisitionCodeMaintenanceReducer.isDiscountFlag,
            acquisitionCodeMaintenanceGridFilters: state.GridFiltersReducer.acquisitionCodeMaintenanceGridFilters,
            userDetails: userProfileSelectors.getUserDetails(state),
        })
    )
    const pageNavigation = () => {
        if(!isAuthorized(permissions.ViewAdmin) && userDetails?.emailId){
            navigate('/ordermanagement/blank');
        }else{
            navDispatch("Admin");
            dispatchHeaderNav("Admin");
            setSearchValue(acquisitionCodeMaintenanceGridFilters?.orderSearchBoxValue || '');
            selectUpdatedBy.current = acquisitionCodeMaintenanceGridFilters?.updatedBy ?? '';
            updatedDate.current = acquisitionCodeMaintenanceGridFilters?.updatedDate ? new Date(acquisitionCodeMaintenanceGridFilters?.updatedDate) : null;
        } 
    }
    useEffect(() => {
        if(userDetails?.emailId){
        pageNavigation()
        setTimeout(() => {
            setShowGrid(true);
          })
        }
    },[userDetails?.emailId])

    useEffect(() => {
        pageNavigation()   
    }, [])

    useEffect(() => {
        const dropdownList: any = updatedByList?.map((item: any) => {
            return { label: item.text, key: item.value, ...item }
        })
        updatedByDropdownList.current = dropdownList
    }, [updatedByList])

    useEffect(() => {
        setDescriptionFilter(acquisitionCodeMaintenanceGridFilters?.acquisitionDescription)
    }, [acquisitionCodeMaintenanceGridFilters?.acquisitionDescription])

    useEffect(() => {
        setCodeFilter(acquisitionCodeMaintenanceGridFilters?.acquisitionCode)
    }, [acquisitionCodeMaintenanceGridFilters?.acquisitionCode])

    useEffect(() => {
        if (acquisitionCodeMaintenanceGridData?.data?.length) {
            const updatedOrderList = acquisitionCodeMaintenanceGridData?.data?.map((item: any) => ({
                ...item,
                modified: moment(item.modified).format("MM/DD/YYYY"),
            }));
            setGridData(updatedOrderList);
        } else {
            setGridData([]);
        }
        setServerTotal(acquisitionCodeMaintenanceGridData?.totalRecords)
    }, [acquisitionCodeMaintenanceGridData])

    useEffect(() => {
        if(acquisitionCodeMaintenanceExcelData?.length){
            const bytes = base64ToArrayBuffer(acquisitionCodeMaintenanceExcelData);
            saveByteArray("AcquisitionCodeMaintenance", bytes, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            dispatch(setAcquisitionCodeMaintenanceExcelData([]))
        }
    }, [acquisitionCodeMaintenanceExcelData])

    useEffect(() => {
        !(updatedByDropdownList?.length > 0) && dispatch(getUpdatedByAcquisitionList());
    }, [])

    useEffect(() => {
        if (serverTotal && paginationData?.pageSize) {
            let pageSize = paginationData?.pageSize
            let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
            setPagesCount(tempPageCount)
        }
    }, [serverTotal, paginationData?.pageSize])

    const setFilters = (value: any) => {
        if (JSON.stringify(value) !== '{}') {
            dispatch(GridDataFiltersAction.setAcquisitionCodeMaintenanceFilters(value))
        }
    }

    const onSearchOrder = (e: any, isKeyPress?: any) => {
        setSearchValue((isKeyPress ? e : e?.target?.value))
        dispatch(GridDataFiltersAction.setAcquisitionCodeMaintenanceFilters({ orderSearchBoxValue: (isKeyPress ? e : e?.target?.value) }))
    }

    const onChangeDiscountFlag = (data:any) => {
        dispatch(setDiscountFlag(false));
        dispatch(saveDiscountFlag(
            {   "acquisitionCodeDiscountId": data?.acquisitionCodeDiscountId,
                "discountFlag": !data?.discountFlag,
                "savedBy": userDetails?.emailId
            }))
    }

    const getFilteredValues = () => {
        let filteredValues: any = [];
        if (updatedDate.current != null) {
            filteredValues.push({ 'field': COLUMN_FILTERS.UPDATED_DATE, 'value': moment(new Date(updatedDate.current)).format('YYYY-MM-DD') })
        }
        if (selectUpdatedBy.current != "") {
            const findValue = updatedByDropdownList?.current?.find((item: any) => item.label === selectUpdatedBy.current)
            filteredValues.push({ 'field': COLUMN_FILTERS.UPDATED_BY, 'value': findValue?.value })
        }
        if (selectDiscountFlag.current != "") {
            const findValue = discountFlagDropdownList?.find((item: any) => item.label === selectDiscountFlag.current)
            filteredValues.push({ 'field': 'discountFlag', 'value': findValue?.value })
        }
        if (descriptionFilter != "" && descriptionFilter) {
            filteredValues.push({ 'field': 'acquisitionDescription', 'value': descriptionFilter })
        }
        if (codeFilter != "" && codeFilter) {
            filteredValues.push({ 'field': 'acquisitionCode', 'value': codeFilter })
        }
        return filteredValues;
    }

    const debounceObject = [
        paginationData, searchValue, updatedDate, descriptionFilter, codeFilter, selectUpdatedBy, selectDiscountFlag, sortData
    ]

    const globalDebounce = useDebounce(debounceObject, 500)

    useEffect(() => {
        const payload = getGridData();
        if (payload.pageNumber && payload.pageSize) {
            dispatch(getAcquisitionCodeMaintenanceGridData(payload));
        }
    }, [globalDebounce])

    useEffect(() => {
        if(isDiscountFlag){
            const payload = getGridData();
            if (payload.pageNumber && payload.pageSize) {
                dispatch(getAcquisitionCodeMaintenanceGridData(payload));
            }
        }
    }, [isDiscountFlag])

    const getGridData = () => {
        let payload: any = {
            "pageNumber": paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined,
            "pageSize": paginationData?.pageSize,
            "columnFilters": getFilteredValues()
        }

        if (searchValue != '') {
            payload.globalSearch = searchValue
        }

        if (sortData?.key != '') {
            payload.sortBy = sortData?.key;
            payload.sortOrder = sortData?.sortDirection;
        }
        return payload; 
    }

    const fetchAction = useCallback((fetchData: any) => {
        if (fetchData.action && fetchData.action === "paging") {
            setPaginationData(fetchData.data)
        }
        if (fetchData.action && fetchData.action === "sorting") {
            setSortData(fetchData.data[0]);
        }
    }, [])
    const acquisitionCodeMaintenanceColumns = [
        {
            key: "acquisitionDescription",
            title: "Acquisition Code Description",
            width: 200,
            filterRowValue: acquisitionCodeMaintenanceGridFilters?.acquisitionDescription ?? ''
        },
        {
            key: "acquisitionCode",
            title: "Acquisition Code",
            width: 100,
            filterRowValue: acquisitionCodeMaintenanceGridFilters?.acquisitionCode ?? ''
        },
        {
            key: "discountFlag",
            title: "Discount Flag",
            Cell: (row: any) => {
                return (
                    <SwitchToggle checked={row.rowData.discountFlag} 
                    disabled={!(isAuthorized(permissions.ViewAdmin) && isAuthorized(permissions.Create_Edit_Admin))}
                    onChange={(item:any) => {
                        onChangeDiscountFlag(row.rowData);
                     }}  data-attribute="AcquisitionCodeMaintenance_container_Default_SwitchToggle" />
                );
            },
            width: 100,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent
                    {...props}
                    setDropdown={selectDiscountFlag}
                    options={discountFlagDropdownList}
                />
            ),
        },
        {
            key: "modified",
            title: "Updated Date",
            FilterCell: (props: any) => {
                return <CustomDateFilterComponent {...props} setDate={updatedDate} />;
            },
            width: 100,
        },
        {
            key: "modifiedByName",
            title: "Updated By",
            width: 100,
            FilterCell: (props: any) => (
                <CustomDropdownFilterComponent
                    {...props}
                    setDropdown={selectUpdatedBy}
                    options={updatedByDropdownList.current}
                />
            ),
        }
    ];


    const onExportExcel = (e: any) => {
        e.preventDefault();
        const payload = getGridData();
        if (payload.pageNumber && payload.pageSize) {
            dispatch(getAcquisitionCodeMaintenanceExcelData(payload));
        }
    }

    const breadcrumlist = [
        { text: 'Admin Settings', key: 'f1', href: '/ordermanagement', onClick: (e: any) => { e.preventDefault(); navigate('/ordermanagement'); navDispatch('Admin'); dispatchHeaderNav('Admin'); } },
        { text: 'Acquisition Code Maintenance', key: 'f2' }
    ]

    const createNewAcquisitionOnClick = () => {
        navigate('/ordermanagement/createacquisitionnewcode')
    }

    return (
        <AcquisitionCodeMaintenance
            acquisitionCodeMaintenanceColumns={acquisitionCodeMaintenanceColumns}
            gridData={gridData}
            setFilters={setFilters}
            serverTotal={serverTotal}
            fetchAction={fetchAction}
            pagesCount={pagesCount}
            onSearchOrder={onSearchOrder}
            searchValue={searchValue}
            onExportExcel={onExportExcel}
            breadcrumlist = {breadcrumlist}
            createNewAcquisitionOnClick = {createNewAcquisitionOnClick}
            showGrid = {showGrid}
        />
    )
}

export default AcquisitionCodeMaintenanceContainer